import Image from '../UI/Image';
import RichText from '../UI/Richtext';
import CTA from '../UI/Cta';
import { ReactElement } from 'react';
import { IComponentImageLeftTextRightFields } from 'types/contentful';
import { LINK_CONTENT_TYPE } from 'lib/consts';
import IFrameCTA from 'components/UI/IFrameCta';

export interface LeftImageRightTextProps extends IComponentImageLeftTextRightFields {
  rightImage?: boolean;
}

export default function LeftImageRightText({
  anchorLinkId = undefined,
  body,
  image,
  title,
  cta,
  backgroundColor,
  rightImage,
  headingAlignment = 'Left',
  imageRatio = 'default',
}: LeftImageRightTextProps): ReactElement {
  return (
    <div
      {...(anchorLinkId ? { id: anchorLinkId } : {})}
      className={`bg-${backgroundColor} text-primary-actual ecp-my ${
        backgroundColor === 'white' || !backgroundColor ? 'pb-10 lg:pb-20' : 'py-10 lg:py-20'
      }`}
    >
      <div className="mx-auto px-site-component">
        <div
          className={`w-full flex flex-col-reverse gap-8 lg:gap-12 xl:gap-16 items-center ${
            rightImage ? 'lg:flex-row-reverse' : 'lg:flex-row'
          }`}
        >
          <div className="w-full lg:w-1/2">
            {image && (
              <div style={{ aspectRatio: imageRatio === 'default' ? '4 / 3' : 'auto' }}>
                <Image
                  image={image}
                  query="w=672"
                  classNames="w-full h-full object-cover m-auto lg:m-0"
                />
              </div>
            )}
          </div>

          <div className="w-full lg:w-1/2 text-left">
            <div
              className={`flex items-center mb-6 lg:mb-8 ${
                headingAlignment === 'Left' ? 'justify-start' : 'justify-start'
              }`}
            >
              <h2
                className={`bordered-heading font-heading text-new-34 lg:text-4xl lg:leading-new-43 ${
                  backgroundColor === 'primary' ? 'text-white' : 'text-primary-actual'
                }`}
              >
                {title}
              </h2>
            </div>

            {body !== undefined && (
              <RichText document={body} classNames="image-text-richtext text-lg" />
            )}

            {cta !== undefined && (
              <div className="hidden lg:flex mt-8">
                {cta.sys?.contentType?.sys?.id === LINK_CONTENT_TYPE.fragmentIFrameCta ? (
                  <IFrameCTA {...cta.fields} backgroundColor="black" />
                ) : (
                  <CTA {...cta.fields} backgroundColor={backgroundColor || 'white'} classNames="" />
                )}
              </div>
            )}
          </div>
        </div>
        {cta !== undefined && (
          <div className="lg:hidden mt-8">
            {cta.sys?.contentType?.sys?.id === LINK_CONTENT_TYPE.fragmentIFrameCta ? (
              <IFrameCTA {...cta.fields} backgroundColor="black" />
            ) : (
              <CTA {...cta.fields} backgroundColor={backgroundColor || 'white'} />
            )}
          </div>
        )}
      </div>
    </div>
  );
}
